import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  withStyles,
  Button,
  Grid,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Dialog,
  DialogTitle,
  DialogContent,
} from "@material-ui/core";
import { GetApi } from "../../../js_assets/Network";
import AgGridTable from "../../agGridTable";

import LoadingIcon from "../../LoadingIcon";

import CircularProgress from "@material-ui/core/CircularProgress";

import AppAdminContainer from "../AppAdminContainer";
import Divider from "@material-ui/core/Divider";

import Hammer from "react-hammerjs";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    marginTop: 8,
    margin: 12,
  },
  divider: {
    width: "100%",
  },

  ButtonGuide: {
    backgroundColor: "#74cbc4",
    color: "white",
    "&:hover": {
      background: "#74cbc4",
    },
    margin: theme.spacing.unit,
    padding: "4px",
  },
  Table: {
    width: "90%",

    fontFamily: ["DIN-NEXT™-ARABIC-BOLD"].join(","),
  },
});

class DiscountCode extends Component {
  constructor(props) {
    super(props);
    this.state = {
      Discount_Code: [],
      Admin_Info: JSON.parse(localStorage.getItem("Admin_Info")),
      loading_state_iocn: true,
      AllTrainers: [],
      Stores: [],
      Purchased_By_Code_Model: false,
      Purchased_By_Code_Data: [],
    };
  }

  componentDidMount() {
    this.init_data();
  }

  init_data = () => {
    const { Admin_Info } = this.state;
    Promise.all([
      GetApi(
        `/api/Admin/Get_Discount_Codes/${Admin_Info.admin_Id}`,
        Admin_Info.jwT_Token_Admin
      ),
      GetApi(`/api/trainer/GetAllTrainers`, Admin_Info.jwT_Token_Admin),
      GetApi(
        `/api/store/GetStores/${Admin_Info.admin_Id}`,
        Admin_Info.jwT_Token_Admin
      ),
    ]).then((rep) => {
      this.setState({
        Discount_Code: rep[0],
        AllTrainers: rep[1],
        Stores: rep[2],
        loading_state_iocn: false,
      });
    });
  };

  get_Trainer = (id) => {
    const { AllTrainers } = this.state;

    let result = "للجميع";

    AllTrainers.map((item) => {
      if (item.trainer_Id == id) {
        result = item.trainer_Name;
      }
    });

    return result;
  };

  get_Stores = (id) => {
    const { Stores } = this.state;

    let result = "للجميع";

    Stores.map((item) => {
      if (item.store_Id == id) {
        result = item.store_Name;
      }
    });

    return result;
  };

  GetException = (exception_Discount_Ids, type) => {
    if (exception_Discount_Ids !== null) {
      exception_Discount_Ids = exception_Discount_Ids.split("-");

      exception_Discount_Ids =
        exception_Discount_Ids.length !== 0
          ? exception_Discount_Ids.filter((e) => e !== "" || e !== null)
          : exception_Discount_Ids;

      return (
        <div>
          <ul>
            {exception_Discount_Ids.map((item, index) => {
              if (type === "store") {
                return (
                  <li>{index + 1 + " - " + this.get_Stores(parseInt(item))}</li>
                );
              } else {
                return (
                  <li>
                    {index + 1 + " - " + this.get_Trainer(parseInt(item))}
                  </li>
                );
              }
            })}
          </ul>
        </div>
      );
    }
  };

  Get_Discount_Code_For_Exception = (code) => {
    if (
      code.type_Discount_Code_For === "subscription_schedule" &&
      code.iD_Discount_Code_For === "all"
    ) {
      return this.GetException(
        code.exception_Discount_Ids,
        "subscription_schedule"
      );
    } else if (
      code.type_Discount_Code_For === "store" &&
      code.iD_Discount_Code_For === "all"
    ) {
      return this.GetException(code.exception_Discount_Ids, "store");
    }
  };

  redirectToUrl = (Component) => {
    window.location.href =
      window.location.protocol +
      "//" +
      window.location.hostname +
      ":" +
      window.location.port +
      Component;
  };

  Delete_Discount_Code = (ID) => {
    const { Admin_Info } = this.state;

    GetApi(
      `/api/Admin/Delete_Discount_Code/${ID}/${Admin_Info.admin_Id}`,
      Admin_Info.jwT_Token_Admin
    ).then(() => {
      alert("تم الحدف");
      this.init_data();
    });
  };

  Opne_Purchased_By_Code_Model = (discount_Code_Id, type_Discount_Code_For) => {
    const { Admin_Info } = this.state;

    this.setState({ loading_state_iocn: true });

    if (type_Discount_Code_For === "subscription_schedule") {
      GetApi(
        `/api/trainer/Get_Purchased_By_Code_Subscription_schedule/${discount_Code_Id}/${Admin_Info.admin_Id}`,
        Admin_Info.jwT_Token_Admin
      ).then((rep) => {
        if (rep !== 0) {
          this.setState({ Purchased_By_Code_Data: rep });
          this.Table();
        }
      });

      this.setState({
        loading_state_iocn: false,
        Purchased_By_Code_Model: true,
      });
    }
  };
  Table = () => {
    let columnDefs = [
      { headerName: "اسم المدرب", field: "trainer_Name" },
      { headerName: "اسم الجدول  ", field: "followUp_Schedule_Name" },
      {
        headerName: "قيمة الاشتراك< ",
        field: "subscription_Price",
      },
      { headerName: "قيمة قبل الخصم ", field: "original_Subscription_Price" },
      { headerName: "تاريخ الاشتراك ", field: "subscription_Date" },

      { headerName: "اسم العميل  ", field: "userName" },
      { headerName: "الجوال ", field: "user_Phone" },
      { headerName: "الايميل ", field: "user_Email" },
      { headerName: " رقم الحواله ", field: "payment_Transaction_Id" },
    ];

    this.setState({
      columnDefs: columnDefs,
      rowData: this.state.Purchased_By_Code_Data,
    });
  };

  render() {
    const { classes } = this.props;
    const { Discount_Code, loading_state_iocn } = this.state;

    return (
      <AppAdminContainer Title={"اكواد الخصم"}>
        {loading_state_iocn && <LoadingIcon />}
        <div>
          <Grid container justify="center">
            <Hammer
              onTap={() =>
                this.redirectToUrl("/Admin/FormDiscountCode?CodeId=New")
              }
            >
              <div style={{ paddingTop: "5%" }}>
                <button
                  size="small"
                  variant="contained"

                >
                  <label> اضافة كود خصم</label>
                </button>
              </div>
            </Hammer>
          </Grid>
        </div>

        <Divider className={classes.divider} />

        {Discount_Code.length !== 0 && (
          <Grid
            style={{ paddingRight: "6%", paddingTop: "20px" }}
            justify="center"
            alignItems="center"
            container
            spacing={8}
          >
            {/* <AgGridTable
              columnDefs={this.state.columnDefs}
              rowData={this.state.rowData}
            /> */}
            <Table className={classes.Table}>
              <TableHead>
                <TableRow>
                  <TableCell>اسم المعلن </TableCell>
                  <TableCell>كود الخصم</TableCell>
                  <TableCell> نسبة الخصم</TableCell>
                  <TableCell> تايخ الانشاء </TableCell>
                  <TableCell> تاريخ الانتهاء </TableCell>
                  <TableCell> موجهه لل </TableCell>
                  <TableCell> مخصص </TableCell>
                  <TableCell> المستثنى </TableCell>
                  <TableCell> عدد المحاولات </TableCell>
                  <TableCell> شرط الخصم </TableCell>
                  <TableCell> عدد الشراء </TableCell>

                  <TableCell> الاجراء </TableCell>
                  <TableCell> الاجراء </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {Discount_Code.map((code, index) => {
                  return (
                    <TableRow>
                      <TableCell>{code.advertiser_Name}</TableCell>
                      <TableCell>{code.coupon_Code}</TableCell>
                      <TableCell>
                        {parseFloat(code.discount_Percent * 100) + "%"}
                      </TableCell>
                      <TableCell>
                        {code.discount_Code_Datetime.split("T")[0]}
                      </TableCell>
                      <TableCell>
                        {code.expiry_Code_Date.split("T")[0]}
                      </TableCell>
                      <TableCell>
                        {code.type_Discount_Code_For === "subscription_schedule"
                          ? "جداول"
                          : "متاجر"}
                      </TableCell>
                      <TableCell>
                        {code.iD_Discount_Code_For !== "all" &&
                          code.type_Discount_Code_For === "subscription_schedule"
                          ? this.get_Trainer(
                            parseInt(code.iD_Discount_Code_For)
                          )
                          : this.get_Stores(
                            parseInt(code.iD_Discount_Code_For)
                          )}
                      </TableCell>
                      <TableCell>
                        {this.Get_Discount_Code_For_Exception(code)}
                      </TableCell>
                      <TableCell>{code.count_Use_Code}</TableCell>
                      <TableCell>{code.discount_Condition}</TableCell>
                      <TableCell>
                        {
                          <button
                            size="small"
                            variant="outlined"
                            onClick={() =>
                              this.Opne_Purchased_By_Code_Model(
                                code.discount_Code_Id,
                                code.type_Discount_Code_For
                              )
                            }
                          >
                            <span className="span12px">
                              {" "}
                              {code.count_Purchased_By_Code}
                            </span>
                          </button>
                        }
                      </TableCell>
                      <TableCell>
                        {
                          <button
                            size="small"
                            variant={"outlined"}
                            className={classes.ButtonGuide}
                            onClick={() =>
                              this.redirectToUrl(
                                `/Admin/FormDiscountCode?CodeId=${code.discount_Code_Id}`
                              )
                            }
                          >
                            <span className="span12px"> تحديث</span>
                          </button>
                        }
                      </TableCell>
                      <TableCell>
                        {
                          <button
                            size="small"
                            variant={"outlined"}
                            style={{ borderColor: "red", color: "red" }}
                            onClick={() => {
                              if (window.confirm("هل متاكد انك تبغى تحدف  ؟؟"))
                                this.Delete_Discount_Code(
                                  code.discount_Code_Id
                                );
                            }}
                          >
                            <span className="span12px"> حذف الكود</span>
                          </button>
                        }
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </Grid>
        )}

        <Dialog
          fullWidth={"lg"}
          maxWidth={"lg"}
          fullScreen={true}
          open={this.state.Purchased_By_Code_Model}
        >
          <DialogTitle id="form-dialog-title">
            <button
              onClick={() =>
                this.setState({
                  Purchased_By_Code_Model: false,
                  Purchased_By_Code_Data: [],
                })
              }
              variant="text"
            >
              X
            </button>
          </DialogTitle>

          <DialogContent>
            {this.state.Purchased_By_Code_Data.length !== 0 ? (
              <Grid
                style={{ paddingTop: "15px" }}
                justify="center"
                alignItems="center"
                container
                spacing={8}
              >
                <AgGridTable
                  columnDefs={this.state.columnDefs}
                  rowData={this.state.rowData}
                />
              </Grid>
            ) : (
              <h4> لاتوجد بيانات </h4>
            )}
          </DialogContent>
        </Dialog>
      </AppAdminContainer>
    );
  }
}
DiscountCode.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(DiscountCode);
